module.exports = __webpack_public_path__ + "assets/game-type-unscramble-word.cb7d2a11.svg";